
import { Component, Vue, Prop } from 'vue-property-decorator';
import CardOrdine from './CardOrdine.vue';
import { OrdineSlim } from '@/models';

@Component({
  components: { 
      CardOrdine 
    }
})
export default class OrdiniCards extends Vue {
    @Prop() private ordini!: OrdineSlim[];
    @Prop({ default: false }) private compact!: boolean;
}
